import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('no');

  useEffect(() => {
    localStorage.setItem('language', 'no');
  }, []);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage || 'no');
  };

  const value = {
    language,
    setLanguage: changeLanguage,
    changeLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
